export default "__VITE_ASSET__CIQumfv8__"